import { motion } from "motion/react";
import { postIpc } from "../../lib/ipc";

type LaunchItem = {
  label: string;
  blurb: string;
  target: string;
  accent: string;
  sprite: string[];
};

const items: LaunchItem[] = [
  {
    label: "Browser",
    blurb: "live page work",
    target: "browser",
    accent: "mint",
    sprite: ["011110", "110011", "110011", "110011", "011110", "001100"],
  },
  {
    label: "Project Chat",
    blurb: "repo turns",
    target: "chat",
    accent: "violet",
    sprite: ["011100", "110010", "110010", "111110", "011110", "001100"],
  },
  {
    label: "Files",
    blurb: "editor flow",
    target: "files",
    accent: "cyan",
    sprite: ["111100", "110000", "111100", "110000", "111110", "111110"],
  },
  {
    label: "Project Tools",
    blurb: "capability notes",
    target: "tools",
    accent: "amber",
    sprite: ["111111", "011110", "001100", "111111", "001100", "011110"],
  },
  {
    label: "Canvas",
    blurb: "prompt layouts",
    target: "canvas",
    accent: "cyan",
    sprite: ["111111", "100001", "101101", "101101", "100001", "111111"],
  },
  {
    label: "Global Settings",
    blurb: "package cache",
    target: "settings",
    accent: "mint",
    sprite: ["011110", "110011", "101101", "101101", "110011", "011110"],
  },
];

function MenuSprite({ accent, sprite }: { accent: string; sprite: string[] }) {
  return (
    <span
      className={`menu-sprite menu-sprite--${accent}`}
      style={{ ["--sprite-columns" as string]: String(sprite[0]?.length ?? 0) }}
      aria-hidden="true"
    >
      {sprite.flatMap((row, rowIndex) =>
        row.split("").map((token, columnIndex) => (
          <span
            key={`${rowIndex}-${columnIndex}`}
            className={token === "1" ? "menu-sprite__cell is-on" : "menu-sprite__cell"}
          />
        )),
      )}
    </span>
  );
}

export function LaunchRail({ projectName }: { projectName: string }) {
  return (
    <div className="launch-rail">
      <div className="launch-rail__header">
        <span className="launch-rail__eyebrow">menu</span>
        <span className="launch-rail__hint">{projectName}</span>
      </div>
      <div className="launch-rail__list">
        {items.map((item, index) => (
          <motion.button
            key={item.target}
            type="button"
            className={`launch-line launch-line--${item.accent}`}
            whileHover={{ x: 2 }}
            whileTap={{ scale: 0.995 }}
            onClick={() => postIpc({ kind: `section-${item.target}`, data: item.target })}
          >
            <span className="launch-line__index">{String(index + 1).padStart(2, "0")}</span>
            <MenuSprite accent={item.accent} sprite={item.sprite} />
            <span className="launch-line__body">
              <strong>{item.label}</strong>
              <em>{item.blurb}</em>
            </span>
            <span className="launch-line__arrow">enter</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
